'use client';
import { SessionContext } from '@benzinga/session-context';
import { SubscribableEventType } from '@benzinga/subscribable';
import { UUID } from '@benzinga/session';
import React from 'react';
import Hooks from '@benzinga/hooks';

import { useActiveWorkspaceSubscriber } from '@benzinga/pro-tools';
import { Watchlist, WatchlistManager } from '@benzinga/watchlist-manager';

export const useWatchlist = (watchlistId: UUID, updateCallback?: (watchlist: Watchlist) => void) => {
  const session = React.useContext(SessionContext);
  const update = Hooks.useForceUpdate();
  const watchlistManager = React.useMemo(() => session.getManager(WatchlistManager), [session]);

  useActiveWorkspaceSubscriber(watchlistManager, (event: SubscribableEventType<WatchlistManager>) => {
    switch (event.type) {
      case 'watchlist:updated_watchlist':
        if (event.watchlist.watchlistId === watchlistId) {
          if (updateCallback) {
            updateCallback(watchlistManager.getStoredWatchlistById(watchlistId)!);
          } else {
            update();
          }
        }
        break;
    }
  });

  return watchlistManager.getStoredWatchlistById(watchlistId);
};
